import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  inputFields: {
    minWidth: '326px',
    height: '53px',
    '& .css-bw8hcn-MuiInputBase-input-MuiFilledInput-input.Mui-disabled': {
      '-webkit-text-fill-color': '#000000d9',
    },
  },
}));

export const FeeStartDate = () => {
  const { classes } = useStyles();
  const { control, getValues, clearErrors, setError } = useFormContext();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const feeStartDate: any = useWatch({ name: 'feeStartDate' });
  const isModEdit = useSelector(selectIsEditMod);
  const totalAdminFee: number | null | undefined = useWatch({ name: 'totalAdminFee' });
  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);
  const [required, setRequired] = useState<boolean>();

  const validation = () => {
    if (!(getValues('totalAdminFee') > 0)) {
      clearErrors('feeStartDate');
      setRequired(false);
    } else {
      if (isNullOrUndefined(getValues('feeStartDate')) || getValues('feeStartDate') === '') {
        setError('feeStartDate', {});
        setRequired(true);
      } else {
        clearErrors('feeStartDate');
        setRequired(true);
      }
    }
  };

  useEffect(() => {
    validation();

    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  useEffect(() => {
    validation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feeStartDate]);

  useEffect(() => {
    if (!required) {
      clearErrors('feeStartDate');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [required]);

  return (
    <Controller
      control={control}
      name={'feeStartDate'}
      rules={{
        required: required,
      }}
      render={({ field: { onChange, value, ...rest } }) => {
        const newStartDate = moment(feeStartDate ?? null);
        return (
          <React.Fragment>
            <DateRangePicker
              onChange={newValue => {
                if (newValue.startDate !== undefined) {
                  const newDate = moment(newValue.startDate);
                  const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;
                  onChange(setTo);
                  validation();
                } else {
                  onChange(null);
                  validation();
                }
              }}
              {...rest}
              value={feeStartDate}
              onCancel={() => {}}
              clear
              open={false}
              variant="filled"
              single
              placeholder="Fee Start Date"
              useMaxWidth={true}
              showIcon={true}
              className={classes.inputFields}
              labelClass={classes.inputFields}
              actionBar={false}
              clickAway={true}
              trailingIconShow={true}
              readOnly={
                !isModEdit || isNullOrUndefined(totalAdminFee) || isEmpty(totalAdminFee) || !(totalAdminFee > 0)
              }
              isDisabled={isNullOrUndefined(totalAdminFee) || isEmpty(totalAdminFee) || !(totalAdminFee > 0)}
              required={!isNullOrUndefined(totalAdminFee) && !isEmpty(totalAdminFee) && totalAdminFee > 0}
              keepClickAwayVal={true}
              initialDateRange={{
                startDate: newStartDate.isValid() ? new Date(newStartDate.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                endDate: newStartDate.isValid() ? new Date(newStartDate.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                useLabelAsValue: true,
              }}
            />
          </React.Fragment>
        );
      }}
    />
  );
};
